import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import argocdPlugin from '@roadiehq/backstage-plugin-argo-cd/alpha';
import jenkinsPlugin from '@backstage-community/plugin-jenkins/alpha';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';
import { authModule } from './modules/auth';
import { analyticsModule } from './modules/analytics';

export default createApp({
  features: [
    catalogPlugin,
    navModule,
    homeModule,
    authModule,
    analyticsModule,
    argocdPlugin,
    jenkinsPlugin,
  ],
});
